import type { PlaylistItem } from '@jwp/ott-common/types/playlist';
import { useWatchHistoryStore } from '@jwp/ott-common/src/stores/WatchHistoryStore';
import { useEffect, useState } from 'react';
import { resolveEpisode as resolveEpisodeUtil } from '@jwp/ott-common/src/utils/series';

import useEventCallback from './useEventCallback';

export const useSeriesEpisode = (seriesId: string, episodes: PlaylistItem[], episodeIdParam?: string) => {
  const [resolved, setResolved] = useState<undefined | ReturnType<typeof resolveEpisodeUtil>>();

  const resolveEpisode = useEventCallback((episodeId?: string | null) => {
    if (!episodes.length) return;
    const watchHistoryArray = useWatchHistoryStore.getState().watchHistory;
    const watchHistoryItem = watchHistoryArray.find((episode) => episode?.seriesId === seriesId);

    setResolved(resolveEpisodeUtil({ episodes, watchHistoryItem, episodeId: episodeId || episodeIdParam }));
  });

  useEffect(() => {
    if (episodes.length) resolveEpisode();
  }, [seriesId, episodes, episodeIdParam, resolveEpisode]);

  return {
    episode: resolved?.episode,
    nextEpisode: resolved?.nextEpisode,
    firstEpisode: resolved?.firstEpisode,
    showEpisodeInfo: !!resolved?.showEpisodeInfo,
    resolveEpisode,
  };
};
